<div [ngSwitch]="timeLineType" [ngClass]="{ 'h-full': withCustomTail === true }">
	<div *ngSwitchCase="OLD_DESIGN" style="margin: auto; padding: 16px 16px 0">
		<div *ngIf="!mobileTimeLine" class="custom-timeline hidden-xs">
			<div class="top-timeline-tail"></div>
			<nz-timeline>
				<!--    <nz-timeline-item [nzDot]="temp">Network problems being solved 2015-09-01</nz-timeline-item>-->

				<ul class="ant-timeline">
					<li
						*ngFor="let step of stepsArray"
						[ngClass]="{
							active: step.state === 'active',
							completed: step.state === 'completed',
							inactive: step.state === 'inactive'
						}"
						class="ant-timeline-item ant-timeline-item-left ng-star-inserted"
					>
						<div class="ant-timeline-item-tail"></div>
						<div class="ant-timeline-item-head ant-timeline-item-head-blue">
							<!-- <i nz-icon nzType="check-circle" nzTheme="fill"></i> -->
						</div>

						<div class="ant-timeline-item-content">
							<div class="step-title step-title-position {{ step?.disabled ? 'disabled-text-color' : '' }}">
								<span class="{{ step?.disabled ? 'opacity-p7' : '' }}">{{ step.title | uppercase }}</span>
								<span *ngIf="step?.required" class="required-field required-field-position">*</span>
							</div>
							<div class="{{ step?.disabled ? 'disabled-text' : 'step-desc' }} m-t-2">
								<span class="{{ step?.disabled ? 'opacity-p7' : '' }}">{{ step.description | titlecase }}</span>
								<span *ngIf="!disableCompleteBadge && step.state === 'completed'" class="completed-badge">
									{{ step.extraStatus || 'Completed' }}</span
								>
							</div>
						</div>
					</li>
				</ul>

				<ng-template #temp>
					<i nz-icon nzType="clock-circle-o" style="font-size: 16px"></i>
				</ng-template>
			</nz-timeline>
		</div>
		<div *ngIf="!mobileTimeLine" class="mobile-custom-progress visible-xs">
			<nz-progress
				[nzFormat]="progressText"
				[nzPercent]="getCurrentStepProgress()"
				[nzStrokeWidth]="10"
				[nzWidth]="67"
				nzStrokeColor="#0361F0"
				nzStrokeLinecap="round"
				nzType="circle"
			>
			</nz-progress>
			<ng-template #progressText>
				<div class="progress-text">
					Step<br />
					<strong>{{ currentStepIndex + 1 }}/{{ stepsArray.length }}</strong>
				</div>
			</ng-template>
		</div>

		<div *ngIf="mobileTimeLine">
			<div nz-row>
				<div nz-col nzSpan="16">
					<div class="mobile-timeline-title mobile-timeline-width">
						{{ title | titlecase }}
					</div>
					<div class="m-t-6">
						<span class="mobile-timeline-sub-text mobile-timeline-width">{{ getStepDescription() }}</span>
					</div>
				</div>
				<div nz-col nzSpan="8">
					<div class="float-right">
						<nz-progress
							[nzFormat]="progressText"
							[nzPercent]="getCurrentStepProgress()"
							[nzStrokeWidth]="9"
							[nzWidth]="58"
							nzStrokeColor="#0361F0"
							nzStrokeLinecap="round"
							nzType="circle"
						>
						</nz-progress>
						<ng-template #progressText>
							<div class="progress-text">
								<strong
									><span class="mobile-timeline-active-step">{{ currentStepIndex + 1 }}</span></strong
								>
								<span class="mobile-timeline-sub-text">/{{ stepsArray.length }}</span>
							</div>
						</ng-template>
					</div>
				</div>
				<div nz-col nzSpan="24">
					<div>
						<nz-divider></nz-divider>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div *ngSwitchCase="NEW_DESIGN" class="custom-timeline-wrapper h-full">
		<div *ngIf="!isMobile" class="p-l-32 flex flex-col h-full">
			<div *ngFor="let step of stepsArray; let index = index" [class.h-full]="stepsArray.length - 1 === index">
				<ng-container *ngIf="!step.hide">
					<div *ngIf="step.state === 'inactive'" class="custom-timeline-divider flex-none"></div>
					<div *ngIf="step.state !== 'inactive'" class="custom-timeline-divider-active flex-none"></div>
					<div class="custom-timeline-dots flex-grow">
						<div nz-row>
							<div nz-col nzSpan="4">
								<ng-container
									*ngIf="
										step.state === 'processing' ||
										step.extraStatus === 'PENDING' ||
										step.extraStatus === 'AWAITING_APPROVAL'
									"
								>
									<svg fill="none" height="29" viewBox="0 0 28 29" width="28" xmlns="http://www.w3.org/2000/svg">
										<circle cx="14" cy="14.5" fill="white" r="13" stroke="#0361F0" stroke-width="2" />
										<path
											clip-rule="evenodd"
											d="M14.3415 12.6855V11.6342C12.5537 11.6315 10.9572 12.8402 10.62 14.5695C10.2864 16.2782 11.2823 17.9642 12.9879 18.5788C13.476 18.7548 13.721 19.2721 13.5362 19.7361C13.3718 20.1481 12.922 20.3781 12.4822 20.3008C12.4269 20.2915 12.3717 20.2768 12.3178 20.2575C9.75726 19.3361 8.262 16.8062 8.76278 14.2435C9.26852 11.6508 11.6619 9.84484 14.3415 9.84818V8.97685C14.3415 8.55885 14.9004 8.34352 15.239 8.63218L17.4164 10.4862C17.6366 10.6742 17.6366 10.9888 17.4164 11.1768L15.239 13.0308C14.9004 13.3188 14.3415 13.1042 14.3415 12.6855ZM15.5903 18.6075C15.4501 18.6555 15.3056 18.6955 15.1596 18.7261C14.6504 18.8335 14.3281 19.3128 14.4407 19.7968C14.525 20.1595 14.8296 20.4215 15.1908 20.4855C15.3119 20.5061 15.4394 20.5055 15.5669 20.4788C15.7893 20.4315 16.0082 20.3715 16.2221 20.2995C16.713 20.1335 16.9708 19.6195 16.7966 19.1528C16.6216 18.6855 16.0805 18.4415 15.5903 18.6075ZM17.4681 17.2268C17.4277 17.2842 17.3859 17.3402 17.3413 17.3948C17.0232 17.7875 17.0997 18.3508 17.5134 18.6535C17.6366 18.7428 17.7741 18.7995 17.9171 18.8241C18.2543 18.8835 18.6141 18.7655 18.8387 18.4888C18.906 18.4048 18.9718 18.3182 19.0349 18.2295C19.326 17.8182 19.212 17.2608 18.7799 16.9835C18.3471 16.7082 17.7599 16.8155 17.4681 17.2268ZM19.0802 14.4735C18.5589 14.4602 18.124 14.8688 18.1105 15.3648C18.0978 15.8108 18.4307 16.1828 18.8783 16.2615C18.9265 16.2702 18.9768 16.2755 19.0271 16.2762C19.5477 16.2908 19.9826 15.8928 19.9989 15.3975C19.9989 15.3962 19.9996 15.3782 19.9996 15.3768C20.0138 14.8808 19.598 14.4822 19.0802 14.4735Z"
											fill="#0361F0"
											fill-rule="evenodd"
										/>
									</svg>
								</ng-container>

								<ng-container *ngIf="step.state === 'incomplete' || step.extraStatus === 'REJECTED'">
									<svg fill="none" height="29" viewBox="0 0 28 29" width="28" xmlns="http://www.w3.org/2000/svg">
										<circle cx="14" cy="14.5" fill="white" r="13" stroke="#0361F0" stroke-width="2" />
										<path
											d="M20.0335 18.9712L14.7075 9.08062C14.33 8.37937 13.3244 8.37937 12.9466 9.08062L7.62097 18.9712C7.53901 19.1235 7.49792 19.2944 7.50171 19.4672C7.50549 19.6401 7.55404 19.809 7.64259 19.9575C7.73115 20.106 7.8567 20.229 8.00698 20.3145C8.15726 20.4 8.32714 20.4451 8.50004 20.4453H19.1529C19.3259 20.4453 19.496 20.4005 19.6465 20.3151C19.7969 20.2297 19.9227 20.1067 20.0115 19.9582C20.1002 19.8096 20.1489 19.6406 20.1527 19.4676C20.1566 19.2946 20.1155 19.1236 20.0335 18.9712ZM13.8272 18.9141C13.7036 18.9141 13.5828 18.8774 13.48 18.8087C13.3772 18.7401 13.2971 18.6424 13.2498 18.5282C13.2025 18.414 13.1901 18.2884 13.2142 18.1671C13.2383 18.0459 13.2979 17.9345 13.3853 17.8471C13.4727 17.7597 13.5841 17.7002 13.7053 17.6761C13.8265 17.652 13.9522 17.6643 14.0664 17.7116C14.1806 17.7589 14.2782 17.8391 14.3469 17.9418C14.4156 18.0446 14.4522 18.1654 14.4522 18.2891C14.4522 18.3711 14.4361 18.4524 14.4046 18.5282C14.3732 18.6041 14.3272 18.673 14.2692 18.731C14.2111 18.789 14.1422 18.8351 14.0664 18.8665C13.9906 18.8979 13.9093 18.9141 13.8272 18.9141ZM14.506 12.6281L14.3266 16.4406C14.3266 16.5732 14.2739 16.7004 14.1802 16.7942C14.0864 16.8879 13.9592 16.9406 13.8266 16.9406C13.694 16.9406 13.5668 16.8879 13.473 16.7942C13.3793 16.7004 13.3266 16.5732 13.3266 16.4406L13.1472 12.6297C13.1432 12.5386 13.1575 12.4477 13.1894 12.3623C13.2213 12.2769 13.27 12.1988 13.3327 12.1326C13.3954 12.0664 13.4708 12.0136 13.5543 11.9771C13.6379 11.9407 13.7279 11.9215 13.8191 11.9206H13.8257C13.9174 11.9206 14.0083 11.9391 14.0927 11.9751C14.1771 12.0112 14.2533 12.0639 14.3168 12.1302C14.3802 12.1965 14.4296 12.275 14.4619 12.3609C14.4942 12.4468 14.5088 12.5383 14.5047 12.63L14.506 12.6281Z"
											fill="#0361F0"
										/>
									</svg>
								</ng-container>

								<ng-container *ngIf="step.state === 'completed' && !step.extraStatus">
									<svg fill="none" height="29" viewBox="0 0 28 29" width="28" xmlns="http://www.w3.org/2000/svg">
										<circle cx="14" cy="14.5" fill="#0361F0" r="13" stroke="#0361F0" stroke-width="2" />
										<circle cx="13.5" cy="14" fill="white" r="7.5" />
										<path
											d="M14 24.5C8.47967 24.494 4.00606 20.0204 4 14.5V14.3C4.10993 8.80455 8.63459 4.42797 14.1307 4.5009C19.6268 4.57382 24.0337 9.0689 23.9978 14.5654C23.9619 20.0618 19.4966 24.4989 14 24.5ZM10.1157 14.793C9.72572 14.4045 9.09489 14.4051 8.70568 14.7943C8.31594 15.1841 8.31594 15.816 8.70568 16.2057L10.9206 18.4207C11.5168 19.0168 12.4832 19.0168 13.0794 18.4207L19.295 12.205C19.6848 11.8153 19.6859 11.1837 19.2975 10.7925C18.9072 10.3994 18.2717 10.3983 17.88 10.79L12.2303 16.4397C12.1031 16.567 11.8967 16.5672 11.7692 16.4401L10.1157 14.793Z"
											fill="#0361F0"
										/>
									</svg>
								</ng-container>

								<ng-container *ngIf="step.state === 'completed' && step.extraStatus === 'APPROVED'">
									<svg fill="none" height="29" viewBox="0 0 28 29" width="28" xmlns="http://www.w3.org/2000/svg">
										<circle cx="14" cy="14.5" fill="#0361F0" r="13" stroke="#0361F0" stroke-width="2" />
										<circle cx="13.5" cy="14" fill="white" r="7.5" />
										<path
											d="M14 24.5C8.47967 24.494 4.00606 20.0204 4 14.5V14.3C4.10993 8.80455 8.63459 4.42797 14.1307 4.5009C19.6268 4.57382 24.0337 9.0689 23.9978 14.5654C23.9619 20.0618 19.4966 24.4989 14 24.5ZM10.1157 14.793C9.72572 14.4045 9.09489 14.4051 8.70568 14.7943C8.31594 15.1841 8.31594 15.816 8.70568 16.2057L10.9206 18.4207C11.5168 19.0168 12.4832 19.0168 13.0794 18.4207L19.295 12.205C19.6848 11.8153 19.6859 11.1837 19.2975 10.7925C18.9072 10.3994 18.2717 10.3983 17.88 10.79L12.2303 16.4397C12.1031 16.567 11.8967 16.5672 11.7692 16.4401L10.1157 14.793Z"
											fill="#0361F0"
										/>
									</svg>
								</ng-container>

								<ng-container *ngIf="step.state === 'active' && !step.extraStatus">
									<svg fill="none" height="28" viewBox="0 0 27 28" width="27" xmlns="http://www.w3.org/2000/svg">
										<circle
											cx="13.4999"
											cy="14.0004"
											fill="white"
											r="11.6944"
											stroke="#0361F0"
											stroke-width="2.16667"
										/>
									</svg>
								</ng-container>

								<ng-container *ngIf="step.state === 'inactive' && !step.extraStatus">
									<svg fill="none" height="28" viewBox="0 0 27 28" width="27" xmlns="http://www.w3.org/2000/svg">
										<circle
											cx="13.4999"
											cy="14.0004"
											fill="white"
											r="11.6944"
											stroke="#D5DCE8"
											stroke-width="2.16667"
										/>
									</svg>
								</ng-container>
							</div>
							<div class="custom-timeline-content" nz-col nzSpan="20">
								<span nz-row>
									<span nz-col nzSpan="24">
										<span
											class=" {{
												step.disabled ? 'custom-timeline-content-disabled' : ''
											}} custom-timeline-content-title"
											>{{ step.title }}</span
										>
										<span *ngIf="step.required" class="required-field required-field-position">*</span>
									</span>
									<span nz-col nzSpan="24">
										<span *ngIf="!noFlex" nz-row nzAlign="middle" nzJustify="space-between">
											<span
												class="{{
													step.disabled ? 'custom-timeline-content-disabled' : ''
												}} custom-timeline-content-des"
											>
												{{ step.description | titlecase }}
											</span>
											<div *ngIf="step.state === 'completed' && !step.extraStatus" class="completed-badge">
												{{ 'Completed' }}
											</div>
											<span
												*ngIf="step.state === 'completed' && step.extraStatus === 'APPROVED'"
												class="completed-badge"
											>
												{{ (step.extraStatus | titlecase) || 'Completed' }}
											</span>
											<span *ngIf="step.extraStatus === 'incomplete'" class="in-completed-badge">Incomplete</span>
											<span
												*ngIf="step.extraStatus === 're-do' || step.extraStatus === 'REJECTED'"
												class="re-do-badge"
												>Re-upload Documents</span
											>
											<span
												*ngIf="
													step.extraStatus === 'processing' ||
													step.extraStatus === 'PENDING' ||
													step.extraStatus === 'AWAITING_APPROVAL'
												"
												class="custom-timeline-process-container"
											>
												<span class="custom-timeline-process-text">Verification in progress</span>
												<!-- <span class="custom-timeline-process-count-down">02h : 00m : 00s</span> -->
											</span>
										</span>
										<span *ngIf="noFlex" nz-row nzAlign="middle">
											<span
												class="{{
													step.disabled ? 'custom-timeline-content-disabled' : ''
												}} custom-timeline-content-des m-r-10"
											>
												{{ step.description | titlecase }}
											</span>
											<div *ngIf="step.state === 'completed' && !step.extraStatus" class="completed-badge">
												{{ 'Completed' }}
											</div>
											<span
												*ngIf="step.state === 'completed' && step.extraStatus === 'APPROVED'"
												class="completed-badge"
											>
												{{ (step.extraStatus | titlecase) || 'Completed' }}
											</span>
											<span *ngIf="step.extraStatus === 'incomplete'" class="in-completed-badge">Incomplete</span>
											<span
												*ngIf="step.extraStatus === 're-do' || step.extraStatus === 'REJECTED'"
												class="re-do-badge"
												>Re-upload Documents</span
											>
											<span
												*ngIf="
													step.extraStatus === 'processing' ||
													step.extraStatus === 'PENDING' ||
													step.extraStatus === 'AWAITING_APPROVAL'
												"
												class="custom-timeline-process-container"
											>
												<span class="custom-timeline-process-text">Verification in progress</span>
												<!-- <span class="custom-timeline-process-count-down">02h : 00m : 00s</span> -->
											</span>
										</span>
									</span>
								</span>
							</div>
						</div>
					</div>
					<div *ngIf="stepsArray.length - 1 === index" class="flex-grow h-full">
						<div *ngIf="step.state === 'inactive'" class="custom-timeline-divider-tail h-full"></div>
						<div *ngIf="step.state !== 'inactive'" class="custom-timeline-divider-tail-active h-full"></div>
					</div>
				</ng-container>
			</div>
		</div>
		<div *ngIf="isMobile">
			<div>
				<div nz-row nzAlign="middle" nzJustify="space-between">
					<div>
						<div *ngIf="!hideStepDescription">
							<div class="mobile-timeline-title mobile-timeline-width">
								{{ getStepDescription() }}
							</div>
							<div class="m-t-6">
								<div [title]="mobileNote" class="mobile-timeline-sub-text mobile-timeline-width">
									{{ mobileNote }}
								</div>
							</div>
						</div>
					</div>
					<div>
						<div *ngIf="!hideProgressBar" class="time-line-position">
							<div class="float-right">
								<nz-progress
									[nzFormat]="progressText"
									[nzPercent]="getCurrentStepProgress()"
									[nzStrokeWidth]="10"
									[nzWidth]="58"
									nzStrokeColor="#0361F0"
									nzStrokeLinecap="round"
									nzType="circle"
								>
								</nz-progress>
								<ng-template #progressText>
									<div class="progress-text">
										<strong
											><span class="mobile-timeline-active-step">{{ currentStepIndex + 1 }}</span></strong
										>
										<span class="mobile-timeline-sub-text">/{{ stepsArray.length }}</span>
									</div>
								</ng-template>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div *ngSwitchCase="KAMONA_DESIGN" [ngClass]="{ 'h-full': withCustomTail === true }">
		<div *ngIf="!isMobile" [ngClass]="{ 'flex flex-col h-full': withCustomTail === true }">
			<div class="m-l-37">
				<div *ngFor="let kamonaStep of stepsArray; let index = index">
					<div class="display-flex">
						<div>
							<div class="{{ index ? 'kamona-step-pos' : '' }}">
								<span *ngIf="kamonaStep?.state === 'active'">
									<svg fill="none" height="81" viewBox="0 0 29 81" width="29" xmlns="http://www.w3.org/2000/svg">
										<circle cx="14.5" cy="66.5" fill="white" r="12" stroke="#0361F0" stroke-width="2" />
										<line stroke="#0361F0" stroke-width="2" x1="14.5" x2="14.5" y1="0.111328" y2="54.0373" />
									</svg>
								</span>
								<span *ngIf="kamonaStep?.state === 'inactive'">
									<svg fill="none" height="81" viewBox="0 0 29 81" width="29" xmlns="http://www.w3.org/2000/svg">
										<circle cx="14.5" cy="66.5" fill="white" opacity="0.1" r="12" stroke="#063A4F" stroke-width="2" />
										<line
											opacity="0.1"
											stroke="#063A4F"
											stroke-width="2"
											x1="14.5"
											x2="14.5"
											y1="0.111328"
											y2="54.0373"
										/>
									</svg>
								</span>
								<span *ngIf="kamonaStep?.state === 'completed'">
									<svg fill="none" height="81" viewBox="0 0 28 81" width="28" xmlns="http://www.w3.org/2000/svg">
										<circle cx="14" cy="67" fill="#0361F0" r="12" stroke="#0361F0" stroke-width="2" />
										<circle cx="13.5" cy="66.5" fill="white" r="7.5" />
										<path
											d="M14 77C8.47967 76.9939 4.00606 72.5203 4 67V66.8C4.10993 61.3045 8.63459 56.928 14.1307 57.0009C19.6268 57.0738 24.0337 61.5689 23.9978 67.0653C23.9619 72.5618 19.4966 76.9989 14 77ZM10.1157 67.293C9.72572 66.9045 9.09489 66.9051 8.70568 67.2943C8.31594 67.6841 8.31594 68.3159 8.70568 68.7057L10.9206 70.9206C11.5168 71.5168 12.4832 71.5168 13.0794 70.9206L19.295 64.705C19.6848 64.3152 19.6859 63.6837 19.2975 63.2925C18.9072 62.8994 18.2717 62.8983 17.88 63.29L12.2303 68.9397C12.1031 69.0669 11.8967 69.0671 11.7692 68.9401L10.1157 67.293Z"
											fill="#0361F0"
										/>
										<line stroke="#0361F0" stroke-width="2" x1="14" x2="14" y1="0.611328" y2="54.5373" />
									</svg>
								</span>
								<span *ngIf="kamonaStep?.state === 're-do'">
									<svg fill="none" height="81" viewBox="0 0 28 81" width="28" xmlns="http://www.w3.org/2000/svg">
										<circle cx="14" cy="67" fill="white" r="12" stroke="#0361F0" stroke-width="2" />
										<path
											d="M20.0335 71.4712L14.7075 61.5806C14.33 60.8794 13.3244 60.8794 12.9466 61.5806L7.62097 71.4712C7.539 71.6235 7.49791 71.7944 7.5017 71.9672C7.50549 72.1401 7.55403 72.309 7.64259 72.4575C7.73114 72.606 7.85669 72.729 8.00697 72.8145C8.15725 72.9 8.32713 72.9451 8.50003 72.9453H19.1528C19.3259 72.9453 19.4959 72.9005 19.6464 72.8151C19.7969 72.7297 19.9227 72.6067 20.0114 72.4582C20.1002 72.3096 20.1489 72.1406 20.1527 71.9676C20.1566 71.7946 20.1155 71.6236 20.0335 71.4712ZM13.8272 71.4141C13.7036 71.4141 13.5828 71.3774 13.48 71.3087C13.3772 71.2401 13.2971 71.1424 13.2498 71.0282C13.2025 70.914 13.1901 70.7884 13.2142 70.6671C13.2383 70.5459 13.2979 70.4345 13.3853 70.3471C13.4727 70.2597 13.584 70.2002 13.7053 70.1761C13.8265 70.152 13.9522 70.1643 14.0664 70.2116C14.1806 70.2589 14.2782 70.3391 14.3469 70.4418C14.4156 70.5446 14.4522 70.6654 14.4522 70.7891C14.4522 70.8711 14.4361 70.9524 14.4046 71.0282C14.3732 71.1041 14.3272 71.173 14.2692 71.231C14.2111 71.289 14.1422 71.3351 14.0664 71.3665C13.9906 71.3979 13.9093 71.4141 13.8272 71.4141ZM14.506 65.1281L14.3266 68.9406C14.3266 69.0732 14.2739 69.2004 14.1801 69.2942C14.0864 69.3879 13.9592 69.4406 13.8266 69.4406C13.694 69.4406 13.5668 69.3879 13.473 69.2942C13.3793 69.2004 13.3266 69.0732 13.3266 68.9406L13.1472 65.1297C13.1432 65.0386 13.1575 64.9477 13.1894 64.8623C13.2213 64.7769 13.27 64.6988 13.3327 64.6326C13.3954 64.5664 13.4708 64.5136 13.5543 64.4771C13.6379 64.4407 13.7279 64.4215 13.8191 64.4206H13.8257C13.9174 64.4206 14.0083 64.4391 14.0927 64.4751C14.1771 64.5112 14.2533 64.5639 14.3168 64.6302C14.3802 64.6965 14.4296 64.775 14.4619 64.8609C14.4942 64.9468 14.5088 65.0383 14.5047 65.13L14.506 65.1281Z"
											fill="#0361F0"
										/>
										<line stroke="#0361F0" stroke-width="2" x1="14" x2="14" y1="0.611328" y2="54.5373" />
									</svg>
								</span>
								<span *ngIf="kamonaStep?.state === 'processing'">
									<svg fill="none" height="81" viewBox="0 0 28 81" width="28" xmlns="http://www.w3.org/2000/svg">
										<circle cx="14" cy="67" fill="white" r="12" stroke="#0361F0" stroke-width="2" />
										<path
											clip-rule="evenodd"
											d="M14.3416 65.1855V64.1342C12.5538 64.1315 10.9572 65.3402 10.62 67.0695C10.2864 68.7782 11.2823 70.4642 12.988 71.0788C13.476 71.2548 13.7211 71.7721 13.5362 72.2361C13.3719 72.6481 12.9221 72.8781 12.4822 72.8008C12.427 72.7915 12.3717 72.7768 12.3179 72.7575C9.7573 71.8361 8.26203 69.3062 8.76282 66.7435C9.26856 64.1508 11.662 62.3448 14.3416 62.3482V61.4768C14.3416 61.0588 14.9004 60.8435 15.239 61.1322L17.4164 62.9862C17.6367 63.1742 17.6367 63.4888 17.4164 63.6768L15.239 65.5308C14.9004 65.8188 14.3416 65.6042 14.3416 65.1855ZM15.5903 71.1075C15.4501 71.1555 15.3056 71.1955 15.1597 71.2261C14.6504 71.3335 14.3281 71.8128 14.4407 72.2968C14.525 72.6595 14.8296 72.9215 15.1908 72.9855C15.312 73.0061 15.4395 73.0055 15.567 72.9788C15.7894 72.9315 16.0082 72.8715 16.2222 72.7995C16.713 72.6335 16.9709 72.1195 16.7966 71.6528C16.6217 71.1855 16.0805 70.9415 15.5903 71.1075ZM17.4681 69.7268C17.4277 69.7842 17.3859 69.8402 17.3413 69.8948C17.0233 70.2875 17.0998 70.8508 17.5134 71.1535C17.6367 71.2428 17.7741 71.2995 17.9172 71.3241C18.2543 71.3835 18.6142 71.2655 18.8387 70.9888C18.906 70.9048 18.9719 70.8182 19.0349 70.7295C19.326 70.3182 19.212 69.7608 18.7799 69.4835C18.3471 69.2082 17.7599 69.3155 17.4681 69.7268ZM19.0802 66.9735C18.5589 66.9602 18.124 67.3688 18.1105 67.8648C18.0978 68.3108 18.4307 68.6828 18.8784 68.7615C18.9265 68.7702 18.9768 68.7755 19.0271 68.7762C19.5477 68.7908 19.9826 68.3928 19.9989 67.8975C19.9989 67.8962 19.9996 67.8782 19.9996 67.8768C20.0138 67.3808 19.598 66.9822 19.0802 66.9735Z"
											fill="#0361F0"
											fill-rule="evenodd"
										/>
										<line stroke="#0361F0" stroke-width="2" x1="14" x2="14" y1="0.611328" y2="54.5373" />
									</svg>
								</span>
							</div>
						</div>
						<div>
							<div class="{{ index ? 'kamona-step-details-pos' : 'kamona-step-details-head-pos' }} m-l-17">
								<div>
									<span class="{{ kamonaStep?.state === 'completed' ? 'kamona-step-disabled' : '' }} kamona-step-title">
										{{ kamonaStep?.title }}
									</span>
									<span *ngIf="kamonaStep?.required && kamonaStep?.state !== 'completed'" class="kamona-step-required">
										*
									</span>
								</div>
								<div nz-row nzAlign="middle">
									<div>
										<span
											class="{{
												kamonaStep?.state === 'completed' ? 'kamona-step-disabled' : ''
											}} kamona-step-des m-r-10"
										>
											{{ kamonaStep?.description }}
										</span>
									</div>
									<div>
										<div
											*ngIf="kamonaStep?.state === 'completed'"
											class="kamona-step-completed-badge kamona-step-badge-pos"
										>
											Completed
										</div>
										<div
											*ngIf="kamonaStep?.state === 'incomplete'"
											class="kamona-step-incomplete-badge kamona-step-badge-pos"
										>
											Incomplete
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				*ngIf="addTimelineTail"
				[ngClass]="{ 'kamona-time-line-tail-active': stepsArray?.length === currentStepIndex + 1 }"
				class="kamona-time-line-tail"
			></div>
			<div
				*ngIf="withCustomTail"
				[ngClass]="{ 'kamona-time-line-tail-active': stepsArray?.length === currentStepIndex + 1 }"
				class="w-0 border ml-[50px] mt-[-.2em] border-[rgba(6,_58,_79,_.1)] flex-auto"
			></div>
		</div>
		<div *ngIf="isMobile">
			<div>
				<div nz-row nzAlign="middle" nzJustify="space-between">
					<div nz-col nzSpan="20">
						<div *ngIf="!hideStepDescription">
							<div class="mobile-timeline-title">
								{{ getStepDescription() }}
							</div>
							<div class="m-t-6">
								<div [title]="mobileNote" class="mobile-timeline-sub-text">
									{{ mobileNote }}
								</div>
							</div>
						</div>
					</div>
					<div nz-col nzSpan="4">
						<div *ngIf="!hideProgressBar" class="time-line-position">
							<div class="float-right">
								<nz-progress
									[nzFormat]="progressText"
									[nzPercent]="getCurrentStepProgress()"
									[nzStrokeWidth]="10"
									[nzWidth]="58"
									nzStrokeColor="#0361F0"
									nzStrokeLinecap="round"
									nzType="circle"
								>
								</nz-progress>
								<ng-template #progressText>
									<div class="progress-text">
										<strong
											><span class="mobile-timeline-active-step">{{ currentStepIndex + 1 }}</span></strong
										>
										<span class="mobile-timeline-sub-text">/{{ stepsArray.length }}</span>
									</div>
								</ng-template>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="onboarding-design" *ngSwitchCase="ONBOARDING_DESIGN" [ngClass]="{ 'h-full': withCustomTail === true }">
		<div *ngIf="!isMobile" [ngClass]="{ 'flex flex-col h-full': withCustomTail === true }">
			<div class="m-l-37">
				<div *ngFor="let kamonaStep of stepsArray; let index = index">
					<div
						class="display-flex"
						[ngClass]="{
							'kamona-step-active': kamonaStep.state === 'active',
							'kamona-step-completed': kamonaStep.state === 'completed',
							'kamona-step-inactive': kamonaStep.state === 'inactive'
						}"
					>
						<div>
							<div class="{{ index ? 'kamona-step-pos' : '' }}">
								<span *ngIf="kamonaStep?.state === 'active'">
									<svg fill="none" height="81" viewBox="0 0 29 81" width="29" xmlns="http://www.w3.org/2000/svg">
										<circle cx="14.5" cy="66.5" fill="white" r="12" stroke="#0361F0" stroke-width="2" />
										<line stroke="#0361F0" stroke-width="2" x1="14.5" x2="14.5" y1="0.111328" y2="54.0373" />
									</svg>
								</span>
								<span *ngIf="kamonaStep?.state === 'inactive'">
									<svg fill="none" height="81" viewBox="0 0 29 81" width="29" xmlns="http://www.w3.org/2000/svg">
										<circle cx="14.5" cy="66.5" fill="white" opacity="0.1" r="12" stroke="#063A4F" stroke-width="2" />
										<line
											opacity="0.1"
											stroke="#063A4F"
											stroke-width="2"
											x1="14.5"
											x2="14.5"
											y1="0.111328"
											y2="54.0373"
										/>
									</svg>
								</span>
								<span *ngIf="kamonaStep?.state === 'completed'">
									<svg fill="none" height="81" viewBox="0 0 28 81" width="28" xmlns="http://www.w3.org/2000/svg">
										<circle cx="14" cy="67" fill="#0361F0" r="12" stroke="#0361F0" stroke-width="2" />
										<circle cx="13.5" cy="66.5" fill="white" r="7.5" />
										<path
											d="M14 77C8.47967 76.9939 4.00606 72.5203 4 67V66.8C4.10993 61.3045 8.63459 56.928 14.1307 57.0009C19.6268 57.0738 24.0337 61.5689 23.9978 67.0653C23.9619 72.5618 19.4966 76.9989 14 77ZM10.1157 67.293C9.72572 66.9045 9.09489 66.9051 8.70568 67.2943C8.31594 67.6841 8.31594 68.3159 8.70568 68.7057L10.9206 70.9206C11.5168 71.5168 12.4832 71.5168 13.0794 70.9206L19.295 64.705C19.6848 64.3152 19.6859 63.6837 19.2975 63.2925C18.9072 62.8994 18.2717 62.8983 17.88 63.29L12.2303 68.9397C12.1031 69.0669 11.8967 69.0671 11.7692 68.9401L10.1157 67.293Z"
											fill="#0361F0"
										/>
										<line stroke="#0361F0" stroke-width="2" x1="14" x2="14" y1="0.611328" y2="54.5373" />
									</svg>
								</span>
								<span *ngIf="kamonaStep?.state === 're-do'">
									<svg fill="none" height="81" viewBox="0 0 28 81" width="28" xmlns="http://www.w3.org/2000/svg">
										<circle cx="14" cy="67" fill="white" r="12" stroke="#0361F0" stroke-width="2" />
										<path
											d="M20.0335 71.4712L14.7075 61.5806C14.33 60.8794 13.3244 60.8794 12.9466 61.5806L7.62097 71.4712C7.539 71.6235 7.49791 71.7944 7.5017 71.9672C7.50549 72.1401 7.55403 72.309 7.64259 72.4575C7.73114 72.606 7.85669 72.729 8.00697 72.8145C8.15725 72.9 8.32713 72.9451 8.50003 72.9453H19.1528C19.3259 72.9453 19.4959 72.9005 19.6464 72.8151C19.7969 72.7297 19.9227 72.6067 20.0114 72.4582C20.1002 72.3096 20.1489 72.1406 20.1527 71.9676C20.1566 71.7946 20.1155 71.6236 20.0335 71.4712ZM13.8272 71.4141C13.7036 71.4141 13.5828 71.3774 13.48 71.3087C13.3772 71.2401 13.2971 71.1424 13.2498 71.0282C13.2025 70.914 13.1901 70.7884 13.2142 70.6671C13.2383 70.5459 13.2979 70.4345 13.3853 70.3471C13.4727 70.2597 13.584 70.2002 13.7053 70.1761C13.8265 70.152 13.9522 70.1643 14.0664 70.2116C14.1806 70.2589 14.2782 70.3391 14.3469 70.4418C14.4156 70.5446 14.4522 70.6654 14.4522 70.7891C14.4522 70.8711 14.4361 70.9524 14.4046 71.0282C14.3732 71.1041 14.3272 71.173 14.2692 71.231C14.2111 71.289 14.1422 71.3351 14.0664 71.3665C13.9906 71.3979 13.9093 71.4141 13.8272 71.4141ZM14.506 65.1281L14.3266 68.9406C14.3266 69.0732 14.2739 69.2004 14.1801 69.2942C14.0864 69.3879 13.9592 69.4406 13.8266 69.4406C13.694 69.4406 13.5668 69.3879 13.473 69.2942C13.3793 69.2004 13.3266 69.0732 13.3266 68.9406L13.1472 65.1297C13.1432 65.0386 13.1575 64.9477 13.1894 64.8623C13.2213 64.7769 13.27 64.6988 13.3327 64.6326C13.3954 64.5664 13.4708 64.5136 13.5543 64.4771C13.6379 64.4407 13.7279 64.4215 13.8191 64.4206H13.8257C13.9174 64.4206 14.0083 64.4391 14.0927 64.4751C14.1771 64.5112 14.2533 64.5639 14.3168 64.6302C14.3802 64.6965 14.4296 64.775 14.4619 64.8609C14.4942 64.9468 14.5088 65.0383 14.5047 65.13L14.506 65.1281Z"
											fill="#0361F0"
										/>
										<line stroke="#0361F0" stroke-width="2" x1="14" x2="14" y1="0.611328" y2="54.5373" />
									</svg>
								</span>
								<span *ngIf="kamonaStep?.state === 'processing'">
									<svg fill="none" height="81" viewBox="0 0 28 81" width="28" xmlns="http://www.w3.org/2000/svg">
										<circle cx="14" cy="67" fill="white" r="12" stroke="#0361F0" stroke-width="2" />
										<path
											clip-rule="evenodd"
											d="M14.3416 65.1855V64.1342C12.5538 64.1315 10.9572 65.3402 10.62 67.0695C10.2864 68.7782 11.2823 70.4642 12.988 71.0788C13.476 71.2548 13.7211 71.7721 13.5362 72.2361C13.3719 72.6481 12.9221 72.8781 12.4822 72.8008C12.427 72.7915 12.3717 72.7768 12.3179 72.7575C9.7573 71.8361 8.26203 69.3062 8.76282 66.7435C9.26856 64.1508 11.662 62.3448 14.3416 62.3482V61.4768C14.3416 61.0588 14.9004 60.8435 15.239 61.1322L17.4164 62.9862C17.6367 63.1742 17.6367 63.4888 17.4164 63.6768L15.239 65.5308C14.9004 65.8188 14.3416 65.6042 14.3416 65.1855ZM15.5903 71.1075C15.4501 71.1555 15.3056 71.1955 15.1597 71.2261C14.6504 71.3335 14.3281 71.8128 14.4407 72.2968C14.525 72.6595 14.8296 72.9215 15.1908 72.9855C15.312 73.0061 15.4395 73.0055 15.567 72.9788C15.7894 72.9315 16.0082 72.8715 16.2222 72.7995C16.713 72.6335 16.9709 72.1195 16.7966 71.6528C16.6217 71.1855 16.0805 70.9415 15.5903 71.1075ZM17.4681 69.7268C17.4277 69.7842 17.3859 69.8402 17.3413 69.8948C17.0233 70.2875 17.0998 70.8508 17.5134 71.1535C17.6367 71.2428 17.7741 71.2995 17.9172 71.3241C18.2543 71.3835 18.6142 71.2655 18.8387 70.9888C18.906 70.9048 18.9719 70.8182 19.0349 70.7295C19.326 70.3182 19.212 69.7608 18.7799 69.4835C18.3471 69.2082 17.7599 69.3155 17.4681 69.7268ZM19.0802 66.9735C18.5589 66.9602 18.124 67.3688 18.1105 67.8648C18.0978 68.3108 18.4307 68.6828 18.8784 68.7615C18.9265 68.7702 18.9768 68.7755 19.0271 68.7762C19.5477 68.7908 19.9826 68.3928 19.9989 67.8975C19.9989 67.8962 19.9996 67.8782 19.9996 67.8768C20.0138 67.3808 19.598 66.9822 19.0802 66.9735Z"
											fill="#0361F0"
											fill-rule="evenodd"
										/>
										<line stroke="#0361F0" stroke-width="2" x1="14" x2="14" y1="0.611328" y2="54.5373" />
									</svg>
								</span>
							</div>
						</div>
						<div>
							<div class="{{ index ? 'kamona-step-details-pos' : 'kamona-step-details-head-pos' }} m-l-17">
								<div>
									<span class="{{ kamonaStep?.state === 'completed' ? 'kamona-step-disabled' : '' }} kamona-step-title">
										{{ kamonaStep?.title }}
									</span>
									<span *ngIf="kamonaStep?.required && kamonaStep?.state !== 'completed'" class="kamona-step-required">
										*
									</span>
								</div>
								<div nz-row nzAlign="middle">
									<div>
										<span
											class="{{
												kamonaStep?.state === 'completed' ? 'kamona-step-disabled' : ''
											}} kamona-step-des m-r-10"
										>
											{{ kamonaStep?.description }}
										</span>
									</div>
									<div>
										<div
											*ngIf="kamonaStep?.state === 'completed'"
											class="kamona-step-completed-badge kamona-step-badge-pos"
										>
											Completed
										</div>
										<div
											*ngIf="kamonaStep?.state === 'incomplete'"
											class="kamona-step-incomplete-badge kamona-step-badge-pos"
										>
											Incomplete
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				*ngIf="addTimelineTail"
				[ngClass]="{ 'kamona-time-line-tail-active': stepsArray?.length === currentStepIndex + 1 }"
				class="kamona-time-line-tail"
			></div>
			<div
				*ngIf="withCustomTail"
				[ngClass]="{ 'kamona-time-line-tail-active': stepsArray?.length === currentStepIndex + 1 }"
				class="w-0 border ml-[50px] mt-[-.2em] border-[rgba(6,_58,_79,_.1)] flex-auto"
			></div>
		</div>
		<div *ngIf="isMobile">
			<div>
				<div nz-row nzAlign="middle" nzJustify="space-between">
					<div nz-col nzSpan="20">
						<div *ngIf="!hideStepDescription">
							<div class="mobile-timeline-title">
								{{ getStepDescription() }}
							</div>
							<div class="m-t-6">
								<div [title]="mobileNote" class="mobile-timeline-sub-text">
									{{ mobileNote }}
								</div>
							</div>
						</div>
					</div>
					<div nz-col nzSpan="4">
						<div *ngIf="!hideProgressBar" class="time-line-position">
							<div class="float-right">
								<nz-progress
									[nzFormat]="progressText"
									[nzPercent]="getCurrentStepProgress()"
									[nzStrokeWidth]="10"
									[nzWidth]="58"
									nzStrokeColor="#0361F0"
									nzStrokeLinecap="round"
									nzType="circle"
								>
								</nz-progress>
								<ng-template #progressText>
									<div class="progress-text">
										<strong
											><span class="mobile-timeline-active-step">{{ currentStepIndex + 1 }}</span></strong
										>
										<span class="mobile-timeline-sub-text">/{{ stepsArray.length }}</span>
									</div>
								</ng-template>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
